<template>
  <div>
    <main class="main-content">
      <div class="card">
        <div class="card-body">
          <h6 class="card-title">ویرایش نصاب</h6>
          <form class="border" @submit.prevent="onSubmit" @keydown="form.errors.clear($event.target.name)" enctype="multipart/form-data">
            <div class="form-row d-flex justify-content-center">
              <div class="col-md-4 mb-3">
                <label for="validationCustom01">نام
                  <span class="text-danger">*</span>
                </label>
                <input type="text" class="form-control" placeholder="نام را وارد کنید!" name="name" v-model="form.name">
                <span class="help text-danger" v-if="form.errors.has('name')" v-text="form.errors.get('name')"></span>
              </div>
              <div class="col-md-4 mb-3">
                <label for="validationCustom01">شماره ملی
                    <span class="text-danger">*</span>
                </label>
                <input type="text" class="form-control" placeholder="شماره ملی را وارد کنید!" name="identfication" v-model="form.identfication">
                 <span class="help text-danger" v-if="form.errors.has('identfication')"
                  v-text="form.errors.get('identfication')"></span>
              </div>
            </div>
            <div class="form-row d-flex justify-content-center">
              <div class="col-md-4 mb-3">
                <label for="validationCustom01">شماره موبایل
                    <span class="text-danger">*</span>
                </label>
                <input type="text" class="form-control" placeholder="شماره موبایل را وارد کنید!" name="mobile" v-model="form.mobile">
                 <span class="help text-danger" v-if="form.errors.has('mobile')"
                  v-text="form.errors.get('mobile')"></span>
              </div>
              <div class="col-md-4 mb-3">
                <label for="validationCustom01">آدرس
                  <span class="text-danger">*</span>
                </label>
                <input type="text" class="form-control" placeholder="آدرس را وارد کنید!" name="َaddress"
                  v-model="form.address">
                <span class="help text-danger" v-if="form.errors.has('address')"
                  v-text="form.errors.get('address')"></span>
              </div>
            </div>
            <div class="form-row d-flex justify-content-center">
              <div class="col-md-8 mb-3">
                <label for="validationCustom01">تخصص
                  <span class="text-danger">*</span>
                </label>
                <v-select multiple v-model="form.expertise" :options="options" name="expertise" label="name"></v-select>
                <span class="help text-danger" v-if="form.errors.has('expertise')" v-text="form.errors.get('expertise')"></span>
              </div>
            </div>
            <div class="btn-group d-flex justify-content-center">
              <button class="btn btn-success col-md-2 my-3 btn-pulse" type="submit"
                :disabled="form.errors.any()">ذخیره</button>
              <router-link :to="{name: 'installers.index'}" class="btn btn-dark col-md-2 my-3" type="button"><span
                  class="text-white">بازگشت</span></router-link>
            </div>
          </form>
        </div>
      </div>
    </main>
  </div>
</template>

<script>
export default {
  name: 'StaffEdit',
  data () {
    return {
      profile: null,
      options: [],
      form: new this.$form({
        name: '',
        identfication: '',
        mobile: '',
        address: '',
        expertise: ''
      })
    }
  },
  beforeCreate () {
    this.$send.submit('get', 'api/installers/' + this.$route.params.id + '/edit')
      .then(response => {
        this.options = response.expertise
        this.form.getData(response.installer)
      })
  },
  methods: {
    onSubmit () {
      this.$send.submit('patch', 'api/installers/' + this.$route.params.id, this.form.data())
        .then(response => {
          this.form.onSuccess(response)
          // eslint-disable-next-line no-undef
          swal(
            'تبریک!',
            'نصاب با موفقیت ویرایش شد!',
            'success', {
              button: 'باشه'
            })
          this.$router.push({
            name: 'installers.index'
          })
        }).catch(error => {
          this.form.onFail(error.errors)
        })
    }
  }
}

</script>
